import { useAppDispatch } from "../../../hooks/useRedux";
import CustomButton from "../../components/CustomButton";
import {
  changeLoginType,
  changeSignupType,
  handleUserLoginTabbar,
  handleUserSignupTabbar,
  setHasScroll,
  setOpenAuthSidebar,
  setOpenDriverSidebar,
  setOpenOwnerSidebar,
} from "../../../redux/features/settingSlice";
import { Box, Typography, useTheme } from "@mui/material";
import home_road from "../../../media/images/home_bg1.jpg";
import logoimage from "../../../media/images/logos/KarenTarabarNet-App.png";
import AuthFooter from "../../layout/AuthLayout/Footer";
import MedalIcon from "../../../media/images/icons/medal-icon";
import ShareIcon from "../../../media/images/icons/share-icon";
import PlusMiniIcon from "../../../media/images/icons/plus-mini";
import BigCar from "../../../media/images/icons/bigCar";
import UserProfile from "../../../media/images/icons/user-profile";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useVirtualViewport from "../../../hooks/useVirtualViewport";
import Header from "./Header";
import AuthSidebar from "../../layout/AuthLayout/Sidbar";
import ManageOrders from "../../../media/images/icons/manage-orders";
import Goftino from "../../components/Goftino";
import ChannelLinks from "../../components/ChannelLinks";

const HomePage = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const acc = localStorage.getItem("access_token");
    if (acc) navigate("/driver/dashboard");
    setTimeout(() => {
      setReady(true);
    }, 500);
  }, []);

  const theme = useTheme();

  const navigate = useNavigate();

  const chooseRole = (role: "drivers" | "burdenOwner") => {
    dispatch(changeLoginType("user"));
    dispatch(changeSignupType("user"));
    dispatch(handleUserLoginTabbar(role));
    dispatch(handleUserSignupTabbar(role));
    navigate("/login");
  };

  const viewport = useVirtualViewport();

  const divRef = useRef<HTMLDivElement>(null);
 const getAndroidApp_handle = () => {
   
    window.open(`https://api.karentarabarnet.com/api/Download/GetApk`, "_blank");
  };
  useEffect(() => {
    const divElement = divRef.current;

    const handleScroll = () => {
      if (divElement && divElement.scrollTop > 5) {
        dispatch(setHasScroll(true));
      } else {
        dispatch(setHasScroll(false));
      }
    };

    if (divElement) {
      divElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (divElement) {
        divElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      dispatch(setOpenAuthSidebar(false));
      dispatch(setOpenDriverSidebar(false));
      dispatch(setOpenOwnerSidebar(false));
    }, 100);
  }, [pathname, dispatch]);

  return (
    <Box
      ref={divRef}
      dir="rtl"
      sx={{
        height: `100vh`,
        backgroundColor: "bgColor.grey100",
        paddingBottom: "70px",
        paddingTop: "70px",
        position: "relative",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          "-webkit-appearance": "none",
          width: "0px", // Hides scrollbar for WebKit browsers
        },
        scrollbarWidth: "none", // Hides scrollbar for Firefox
      }}
    >
      {ready ? (
        <>
          <Header />
          <AuthSidebar />
          <Goftino />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              gap: "30px",
              flexDirection: "column",
              paddingX: "8px",
            }}
          >
            <Box
              sx={{
                marginTop: "5px",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  zIndex: 20,
                  boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
                  width: "fit-content",
                  position: "absolute",
                  bottom: "-10%",
                  borderRadius: "20px",
                  backgroundColor: "background.default",
                  padding: "2px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: theme.palette.bgColor.grey100,
                    boxShadow: "0px 2px 20px 0px rgba(0, 0, 0, 0.16) inset",
                    borderRadius: "20px",
                    borderColor: "bgColor.white",
                    borderWidth: "2px",
                    borderStyle: "solid",
                    display: "flex",
                    padding: "6px",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  <img width={200} src={logoimage} alt="" />
                </Box>
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  // border: "1px solid gray",
                  bottom: "20%",
                  width: "95%",
                  display: "flex",
                  alignItems: "start",
                  minHeight: "150px",
                  justifyContent: "space-between",
                  gap: {
                    xs: "10px",
                  },
                }}
              >
                <Box
                  sx={{
                    padding: "8px",
                    backgroundColor: theme.palette.bgColor.grey100,
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                    alignSelf: "end",
                    gap: "4px",
                  }}
                >
                  <ManageOrders size={20} color={theme.palette.primary.main} />
                  <Typography
                    sx={{
                      fontFamily: "IranSans",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                    color={"primary.main"}
                  >
                    مدیریت سفارشات
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                    gap: "10px",
                  }}
                >
                  <Box
                    sx={{
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "8px",
                      backgroundColor: theme.palette.bgColor.grey100,
                      borderRadius: "16px",
                      boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                      gap: "4px",
                    }}
                  >
                    <MedalIcon size={20} color={theme.palette.primary.main} />

                    <Typography
                      sx={{
                        color: "primary.main",
                        fontFamily: "IranSans",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      مناقصات بار{" "}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: theme.palette.bgColor.grey100,
                      borderRadius: "16px",
                      gap: "4px",

                      boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                    }}
                  >
                    <ShareIcon size={20} color={theme.palette.secondary.main} />

                    <Typography
                      sx={{
                        color: "secondary.main",
                        fontFamily: "IranSans",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      صدور بارنامه آنلاین
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <img
                style={{
                  borderRadius: "50% 50% 20px 20px",
                }}
                height={280}
                width={310}
                src={home_road}
                alt=""
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                marginX: "auto",
                width: "80%",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: "15px",
                  color: "textColor.main",
                  mt: "8px",
                }}
              >
                راننده هستید یا صاحب کالا؟
              </Typography>
              <CustomButton
                onClick={() => chooseRole("drivers")}
                flexDirection="row"
                title="راننده هستم"
                justifyContent="space-between"
                bgColor="primary.main"
                width="100%"
                height="72px"
                fSize="16px"
                fWeight="700"
                px="10px"
                py="10px"
                textColor={"#fff"}
                borderRadius="16px"
                icon2={<BigCar color={"#fff"} size={32} />}
                mt="12px"
              />
              <Box>
                <CustomButton
                  onClick={() => chooseRole("burdenOwner")}
                  flexDirection="row"
                  title="صاحب کالا هستم"
                  justifyContent="space-between"
                  bgColor="secondary.main"
                  width="100%"
                  height="72px"
                  fSize="16px"
                  fWeight="700"
                  px="10px"
                  py="10px"
                  textColor={"#fff"}
                  borderRadius="16px"
                  icon2={<UserProfile color={"#fff"} size={32} />}
                  mt="12px"
                />
                 <CustomButton
                  onClick={getAndroidApp_handle}
                  flexDirection="row-reverse"
                  title="دانلود اپلیکیشن اندروید"
                  justifyContent="start"
                  bgColor="green"
                  width="100%"
                  fSize="16px"
                  fWeight="700"
                  px="10px"
                  py="10px"
                  borderRadius="16px"
                  icon2={<PlusMiniIcon size={32} />}
                  mt="8px"
                />
                <Box sx={{ mt: "16px" }}>
                  <ChannelLinks />
                </Box>
              </Box>
              <br />
             
            </Box>
          </Box>
          <AuthFooter />
        </>
      ) : (
        <Typography
          sx={{
            color: theme.palette.primary.main,
            textAlign: "center",
          }}
        >
           لطفا صبر کنید...
        </Typography>
      )}
      {/* </Box> */}
    </Box>
  );
};

export default HomePage;
